import { Text } from '@procurify/ui'
import styled from 'styled-components'

export const GlobalSearchWorkflowsHeadingStyled = styled(Text)`
  padding: ${(props) => props.theme.space.small}
    ${(props) => props.theme.space.medium};
`

export const GlobalSearchWorkflowListStyled = styled.ul`
  margin: 0;
  padding: 0;
  list-style: none;
`

export const GlobalSearchWorkflowStyled = styled.button`
  display: flex;
  align-items: center;
  gap: ${(props) => props.theme.space.medium};
  width: 100%;
  padding: ${(props) =>
    `${props.theme.typography.pxToRem(12)} ${props.theme.space.medium}`};
  border: none;
  border-radius: ${(props) => props.theme.shape.borderRadius}px;
  background: transparent;
  cursor: pointer;
  text-align: left;
  font-family: inherit;

  &:hover {
    background: ${(props) => props.theme.colors.neutral};
  }

  &:focus-visible {
    outline: ${(props) => props.theme.typography.pxToRem(2)} solid
      ${(props) => props.theme.colors.primary};
    outline-offset: ${(props) => props.theme.typography.pxToRem(-2)};
  }
`

export const GlobalSearchWorkflowIconStyled = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: ${(props) => props.theme.typography.pxToRem(48)};
  height: ${(props) => props.theme.typography.pxToRem(48)};
  border-radius: ${(props) => props.theme.shape.borderRadius}px;
  background: ${(props) => props.theme.colors.content.accentBackground};
`

export const GlobalSearchWorkflowContentStyled = styled.div`
  flex: 1;
  min-width: 0;
`

export const GlobalSearchWorkflowTitleStyled = styled(Text)`
  font-size: ${(props) => props.theme.typography.pxToRem(16)};
`
